import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../client/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_toast_e867e216 from 'nuxt_plugin_toast_e867e216' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_vueaxios_727496b9 from 'nuxt_plugin_vueaxios_727496b9' // Source: ../client/plugins/vue-axios (mode: 'client')
import nuxt_plugin_source_3af2d9de from 'nuxt_plugin_source_3af2d9de' // Source: ../client/plugins/source (mode: 'client')
import nuxt_plugin_vuetouch_737c6982 from 'nuxt_plugin_vuetouch_737c6982' // Source: ../client/plugins/vue-touch (mode: 'client')
import nuxt_plugin_vueconfirmv2_08ea7f74 from 'nuxt_plugin_vueconfirmv2_08ea7f74' // Source: ../client/plugins/vue-confirm-v2 (mode: 'client')
import nuxt_plugin_vueconfirmv3_08ea7f72 from 'nuxt_plugin_vueconfirmv3_08ea7f72' // Source: ../client/plugins/vue-confirm-v3 (mode: 'client')
import nuxt_plugin_vuetoastv2_2ecdf250 from 'nuxt_plugin_vuetoastv2_2ecdf250' // Source: ../client/plugins/vue-toast-v2.js (mode: 'client')
import nuxt_plugin_vuepreviewimage_4be0a604 from 'nuxt_plugin_vuepreviewimage_4be0a604' // Source: ../client/plugins/vue-preview-image.js (mode: 'client')
import nuxt_plugin_vueportal_158772ee from 'nuxt_plugin_vueportal_158772ee' // Source: ../client/plugins/vue-portal (mode: 'client')
import nuxt_plugin_imageurlfilter_853abe84 from 'nuxt_plugin_imageurlfilter_853abe84' // Source: ../client/plugins/image-url-filter (mode: 'client')
import nuxt_plugin_vuexgplayer_2b42256d from 'nuxt_plugin_vuexgplayer_2b42256d' // Source: ../client/plugins/vue-xgplayer (mode: 'client')
import nuxt_plugin_vuelogsdk_440ed098 from 'nuxt_plugin_vuelogsdk_440ed098' // Source: ../client/plugins/vue-log-sdk (mode: 'client')
import nuxt_plugin_vuexss_163b0fdb from 'nuxt_plugin_vuexss_163b0fdb' // Source: ../client/plugins/vue-xss (mode: 'all')
import nuxt_plugin_vueoutsideclick_229016a3 from 'nuxt_plugin_vueoutsideclick_229016a3' // Source: ../client/plugins/vue-outside-click (mode: 'client')
import nuxt_plugin_vuelazyload_025de73c from 'nuxt_plugin_vuelazyload_025de73c' // Source: ../client/plugins/vue-lazy-load (mode: 'client')
import nuxt_plugin_vconsole_0d98d997 from 'nuxt_plugin_vconsole_0d98d997' // Source: ../client/plugins/vconsole (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"图虫社区","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=3, minimum-scale=1, user-scalable=no"},{"name":"hotcss","content":"initial-dpr=1,max-width=540"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"x5-fullscreen","content":"true"},{"name":"full-screen","content":"yes"},{"name":"screen-orientation","content":"portrait"},{"name":"x5-orientation","content":"portrait"},{"name":"browsermode","content":"application"},{"name":"x5-page-mode","content":"app"}],"link":[{"hid":"ico","rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fstatic-prod.ituchong.com\u002Ftc-common-fe-static\u002Fimages\u002Ftuchong_pc\u002Ffavicon.ico?1"}],"script":[{"src":"https:\u002F\u002Fstatic-prod.ituchong.com\u002Ftc-common-fe-static\u002Fothers\u002Ftuchong-wap\u002Fobj\u002Fstatic\u002Ffilter-xss\u002Ffilter-xss-lastest.umd.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (process.client && typeof nuxt_plugin_toast_e867e216 === 'function') {
    await nuxt_plugin_toast_e867e216(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueaxios_727496b9 === 'function') {
    await nuxt_plugin_vueaxios_727496b9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_source_3af2d9de === 'function') {
    await nuxt_plugin_source_3af2d9de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouch_737c6982 === 'function') {
    await nuxt_plugin_vuetouch_737c6982(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueconfirmv2_08ea7f74 === 'function') {
    await nuxt_plugin_vueconfirmv2_08ea7f74(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueconfirmv3_08ea7f72 === 'function') {
    await nuxt_plugin_vueconfirmv3_08ea7f72(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoastv2_2ecdf250 === 'function') {
    await nuxt_plugin_vuetoastv2_2ecdf250(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepreviewimage_4be0a604 === 'function') {
    await nuxt_plugin_vuepreviewimage_4be0a604(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueportal_158772ee === 'function') {
    await nuxt_plugin_vueportal_158772ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_imageurlfilter_853abe84 === 'function') {
    await nuxt_plugin_imageurlfilter_853abe84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexgplayer_2b42256d === 'function') {
    await nuxt_plugin_vuexgplayer_2b42256d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelogsdk_440ed098 === 'function') {
    await nuxt_plugin_vuelogsdk_440ed098(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexss_163b0fdb === 'function') {
    await nuxt_plugin_vuexss_163b0fdb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueoutsideclick_229016a3 === 'function') {
    await nuxt_plugin_vueoutsideclick_229016a3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_025de73c === 'function') {
    await nuxt_plugin_vuelazyload_025de73c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vconsole_0d98d997 === 'function') {
    await nuxt_plugin_vconsole_0d98d997(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
